import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import Info from '../../../Components/Info';
import PageHeading from '../../../Components/PageHaeding';
import SectionContainer from '../../../Components/SectionContainer';
import Textarea from '../../../Components/Textarea';
import CustomButton from '../../../Components/CustomButton';
import WarningDialog from '../../../Components/WarningDialog';
import InputField from '../../../Components/Input';
import React, { useEffect, useRef, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  useNavigate,
  useParams,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { Box, Grid, IconButton } from '@mui/material';
import { ImageCropperInput } from '../../../Components/ImageCropperInput';
import AutocompleteSelect from '../../../Components/AutocompleteSelect';
import { PRODUCTION_TYPES } from '../../../Utils/constantData';
import Schedule from './Schedule';
import ClientSection from './ClientSection';
import { CreateProductionFormSchema } from '../../../Utils/yupvalidations';
import Address from './Address';
import { getAllStudiosList } from '../../../redux/StudioSlice';
import NoData from '../../../Components/Nodata';
import ContactsTable from './ContactsTable';
// import AddContact from '../../../Components/AddContact'
import {
  addProduction,
  getProductionDetails,
  removeContactsList,
  setProductionFormDetails,
  updateProduction,
  updateProductionFormDetails,
} from '../../../redux/ProductionSlice';
import { notify } from '../../../Utils/toastify';
import StuioCreate from './StuioCreate';
import { useFormErrorListener } from '../../../Utils/formErrorHook';
import BreadcrumNested from '../../../Components/BreadcrumNested';
import Images from '../../../Utils/images';
import Loading from '../../../Components/Loading';
import { ROUTES } from '../../../helpers/contants';
import { COUNTRY_LIST } from '../../../assets/json/country_dial_info';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { ANALYTICS_EVENTS } from '../../../helpers/analyticsEvents';
import {
  setBreadCrumbs,
  setSelectedEntity,
  removeBreadCrumbs,
  updateBreadcrumbsMethod,
} from '../../../redux/commonSlice';
// import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/** Matches `defaultValues.schedule` when API / draft has no schedule rows. */
const defaultScheduleFormRows = () => [
  { startDate: '' as const, scheduleType: null, endDate: '' as const },
];

export default function CreateProduction() {
  const location = useLocation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { track } = useAnalytics();

  const studioId = searchParams.get('studioId');
  const studioName = searchParams.get('studioName');

  const { productionId }: any = useParams();

  const apiLockRef = useRef<{ [key: string]: boolean }>({});
  const formRef = useRef<HTMLFormElement>(null);

  const [base64File, setBase64File] = useState('');
  const [load, setLoad] = useState(false);
  const [uploadProgress, setUploadProgress] = useState<number | null>(null);
  const [document, setDocument] = useState('');
  const [department, setDepartment] = React.useState<any>({});
  const [studioOpen, setStudioOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [openwarn, setOpenwarn] = useState(false);

  const [open, setOpen] = useState(false);
  const [submitStauts, setSubmitStatus] = useState(false);

  const { contacts, productionFormData, loading } = useSelector(
    (state: any) => state?.production,
  );
  const { breadcrumbs, selectedEntity } = useSelector(
    (state: any) => state?.common,
  );
  // updateBreadcrumbsMethod

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    watch,
    getValues,
    clearErrors,
    trigger,
  } = useForm({
    resolver: yupResolver(CreateProductionFormSchema),
    mode: 'all',
    defaultValues: {
      schedule: defaultScheduleFormRows(),
      address: null,
      clients: [
        {
          firstName: '',
          lastName: '',
          phoneNo: '',
          email: '',
          countryCode: {
            name: 'United States',
            flag: '🇺🇸',
            code: 'US',
            dial_code: '+1',
          },
          isDisabled: false,
        },
      ],
    },
  });

  // const addressWatch

  const {
    fields: documentFields,
    append: appendDocuments,
    remove: removeDocuments,
  } = useFieldArray({
    control,
    name: 'documents', // Name of the field array
  });

  const handleAddDocument = (docDetails: {
    deptId: string;
    docName: string;
    type: string;
    url: string;
  }) => {
    appendDocuments(docDetails); // Add the new document to the documents array
  };

  const handleClose = () => setStudioOpen(!studioOpen);

  useEffect(() => {
    getAllStudiosList();
    // return () => {
    //   // updateProductionFormDetails({});
    //   removeContactsList([]);
    // };
  }, []);

  useEffect(() => {
    if (productionId) {
      getProductionDetails(productionId, (data: any) => {
        Object.entries(data || {}).forEach(([key, value]: any) => {
          if (key === 'image') {
            setBase64File(value);
            return;
          }
          if (key === 'studios') {
            // console.log(getValues('studio'), 'productionId', value);
            setValue(
              'studio',
              getValues('studio')?.length ? [...getValues('studio')] : value,
            );
            return;
          }
          if (key === 'schedule') {
            if (!Array.isArray(value) || value.length === 0) {
              setValue(key, defaultScheduleFormRows());
              return;
            }
            const sch = value.map((item: any) => ({
              _id: item._id,
              startDate: new Date(item?.startDate),
              endDate: new Date(item?.endDate),
              scheduleType: {
                label: item.scheduleType,
                value: item.scheduleType,
              },
            }));
            setValue(key, sch);
            return;
          }

          if (key === 'clients') {
            if (value.length) {
              const updateClients = value.map((item: any) => ({
                _id: item._id,
                email: item.email,
                firstName: item.firstName,
                lastName: item.lastName,
                phoneNo: item.phoneNo,
                countryCode: COUNTRY_LIST?.find(
                  (country: any) =>
                    country.dial_code === item?.countryCode &&
                    country.code === item?.countryAbbreviation,
                ),
              }));

              // console.log('updateClients', updateClients)

              setValue(key, updateClients);
              return;
            } else {
              setValue(key, [
                {
                  firstName: '',
                  lastName: '',
                  phoneNo: '',
                  email: '',
                  countryCode: {
                    name: 'United States',
                    flag: '🇺🇸',
                    code: 'US',
                    dial_code: '+1',
                  },
                  isDisabled: false,
                },
              ]);
              return;
            }
          }

          if (key === 'address') {
            // console.log('=>>>>>>>>>>', value)
            setValue('address', {
              description: value?.address || value?.locationName,
            });
            setValue('zipCode', value?.zipCode);
            setValue('locationName', value?.locationName);
            setValue('country', value?.country);
            setValue('city', value?.city);
            setValue('state', value?.state);
            setValue('addressLine2', value?.addressLine2);
            setValue('addressLine1', value?.address);
            setValue('latitude', data?.location?.coordinates[1]);
            setValue('longitude', data?.location?.coordinates[0]);

            trigger('address');
            return;
          }
          if (key !== 'studios' && key !== 'studio') setValue(key, value);
        });
      });
    }
    if (productionFormData) {
      // Populate all form fields with formData
      Object.entries(productionFormData || {}).forEach(([key, value]: any) => {
        if (key === 'image') {
          setBase64File(value);
          return;
        }

        if (key === 'address') {
          // console.log('=>>>>>>>>>>', value)
          if (value) setValue('address', { description: value?.description });
          // setValue('zipCode', value?.zipCode)
          setValue('country', value?.country);
          // setValue('city', value?.city)
          // setValue('state', value?.state)
          return;
        }

        if (key === 'schedule') {
          if (!Array.isArray(value) || value.length === 0) {
            setValue(key, defaultScheduleFormRows());
          } else {
            setValue(key, value);
          }
          return;
        }

        setValue(key, value);
      });
    }
  }, []);
  useEffect(() => {
    const formData = localStorage.getItem('createProductionFormData');
    const newStudio = localStorage.getItem('newStudio');

    if (formData) {
      const parsedData = JSON.parse(formData);
      Object.entries(parsedData).forEach(([key, value]) => {
        if (key !== 'studios') setValue(key, value);
      });
    }

    if (newStudio) {
      const studioObj = JSON.parse(newStudio);
      const currentStudios = getValues('studio') || [];

      setValue('studio', [...currentStudios, studioObj]);
      // console.log('useEffect', studioObj, currentStudios, getValues('studio'));
      // Clean up
      localStorage.removeItem('newStudio');
      localStorage.removeItem('createProductionFormData');
    }
  }, []);

  // useEffect(() => {
  //   if (studioId && studioName) {
  //     setValue('studio', [
  //       ...getValues('studio'),
  //       { _id: studioId, name: studioName },
  //     ]);
  //   }
  // }, [studioId, studioName]);
  useEffect(() => {
    if (!studioId || !studioName) return;

    const currentStudios = getValues('studio') || [];

    const alreadyExists = currentStudios.some(
      (studio: any) => studio._id === studioId && studio.name === studioName,
    );

    if (!alreadyExists) {
      setValue('studio', [
        ...currentStudios,
        { _id: studioId, name: studioName },
      ]);
    }
  }, [studioId, studioName]);

  const onSubmit = (data: any) => {
    if (apiLockRef.current['submit']) {
      // console.log(`API Locked for ${'submit'}`)
      return;
    }

    apiLockRef.current['submit'] = true; // 🔒 Lock API

    /**
     * Reset breadcrumbs and create only:
     * 1. Production Dashboard
     * 2. Production Details
     */
    const updateProductionBreadcrumbs = (
      productionId: string,
      productionName: string,
    ) => {
      const redirectionData = [
        {
          name: 'production Dashboard',
          type: 'dashboard',
          title: productionName,
          path: `${ROUTES.PRODUCTION_DASHBOARD}?${productionId}`,
        },
        {
          name: 'production Details',
          type: 'details',
          title: productionName,
          path: `${ROUTES.PRODUCTION_DETAIL}/${productionId}`,
        },
      ];

      // Remove all existing breadcrumbs
      removeBreadCrumbs();

      // Add only Production Dashboard and Production Details
      setBreadCrumbs(redirectionData);
    };
    const filterNonEmptyValues = (arr: any) => {
      return arr?.filter((item: any) => {
        return (
          item.firstName !== '' && item.lastName !== '' && item.email !== ''
        );
      });
    };

    // console.log('Final Payload =>>>>>', finalPayload)
    if (productionId) {
      const updatePayload = {
        name: data.name,
        type: data.type,
        ...(data?.customProductionType &&
          data.type === 'Other' && {
            customProductionType: data?.customProductionType,
          }),
        address: {
          // locationName: data.address?.description,
          locationName: data?.locationName,
          city: data.city,
          country: data.country,
          zipCode: data.zipCode,
          state: data.state,
          latitude: data?.latitude,
          longitude: data?.longitude,
          address: data?.addressLine1,
          ...(data?.addressLine2 && { addressLine2: data.addressLine2 }),
        },
        studio: data?.studio?.map((item: any) => item._id) || [],

        ...(data.clients?.length && {
          clients: filterNonEmptyValues(data.clients)?.map(
            ({
              _id,
              firstName,
              lastName,
              phoneNo,
              email,
              countryCode: { dial_code, name, code },
            }: any) => ({
              ...(_id && { _id }),
              firstName,
              lastName,
              phoneNo,
              email,
              country: name,
              countryCode: dial_code,
              countryAbbreviation: code,
            }),
          ),
        }),
        image: base64File,
        description: data.description,
        schedule: data.schedule?.map((item: any) => {
          // console.log('type=>', typeof item.startDate)
          return {
            scheduleType: item.scheduleType.label,
            startDate:
              typeof item.startDate === 'string' && isFinite(item.startDate)
                ? item.startDate
                : dayjs(item.startDate).valueOf(),
            endDate:
              typeof item.endDate === 'string' && isFinite(item.endDate)
                ? item.endDate
                : dayjs(item.endDate).valueOf(),
          };
        }),
      };
      // console.log('=>>FinalPayload ', updatePayload)
      setSubmitStatus(true);
      if (selectedEntity?._id === productionId) {
        dispatch(setSelectedEntity(updatePayload));
      }

      // const updatedBreadcrumbs = breadcrumbs?.map((item: any) => {
      //   if (item.path.includes('production')) {
      //     return {
      //       ...item,
      //       title: data.name,
      //     };
      //   }
      //   return item;
      // });

      // updateBreadcrumbsMethod(updatedBreadcrumbs);

      dispatch(
        updateProduction(productionId, updatePayload, () => {
          // const redirectionData = [
          //   {
          //     name: 'production Details',
          //     type: 'details',
          //     title: data?.name,
          //     path: `${ROUTES.PRODUCTION_DETAIL}/${productionId}`,
          //     // selectedEntity: selectedEntity,
          //   },
          // ];
          // setBreadCrumbs(redirectionData);
          updateProductionBreadcrumbs(productionId, data?.name);
          // notify('Production added successfully', 'success')
          apiLockRef.current['submit'] = false; // 🔓 Unlock API

          removeContactsList([]);
          setBase64File('');
          setSubmitStatus(false);
          navigate(`${ROUTES.PRODUCTION_DETAIL}/${productionId}`);
        }),
      );
    } else {
      const finalPayload = {
        name: data.name,
        type: data.type,
        ...(data?.customProductionType &&
          data.type === 'Other' && {
            customProductionType: data?.customProductionType,
          }),
        address: {
          locationName: data.locationName,
          city: data.city,
          country: data.country,
          zipCode: data.zipCode,
          state: data.state,
          latitude: data?.latitude,
          longitude: data?.longitude,
          address: data?.addressLine1,
          ...(data?.addressLine2 && { addressLine2: data.addressLine2 }),
        },
        ...(data.studio?.length && {
          studio: data.studio.map((item: any) => item._id),
        }),
        ...(filterNonEmptyValues(data?.clients)?.length && {
          clients: filterNonEmptyValues(data.clients)?.map(
            ({
              firstName,
              lastName,
              phoneNo,
              email,
              countryCode: { dial_code, name, code },
            }: any) => ({
              firstName,
              lastName,
              phoneNo,
              email,
              country: name,
              countryCode: dial_code,
              countryAbbreviation: code,
            }),
          ),
        }),
        ...(base64File && { image: base64File }),
        ...(data?.description && { description: data?.description }),
        ...(documentFields?.length && {
          documents: documentFields?.map(
            ({ docName, docFormat, documentUrl, deptId }) => ({
              docName,
              docFormat,
              documentUrl,
              deptId,
            }),
          ),
        }),
        // contacts: contacts?.map(
        //   ({ baseRole, profilePicture, ...item }: any) => ({
        //     ...item,
        //   }),
        // ),
        ...(contacts?.length && {
          contacts: contacts.map(
            ({ baseRole, profilePicture, ...item }: any) => item,
          ),
        }),

        schedule: data.schedule?.map((item: any) => ({
          scheduleType: item.scheduleType.label,
          startDate: dayjs(item.startDate).valueOf(),
          endDate: dayjs(item.endDate).valueOf(),
        })),
      };
      setSubmitStatus(true);

      dispatch(
        addProduction(finalPayload, (data?: any) => {
          apiLockRef.current['submit'] = false; // 🔓 Unlock API
          if (data) {
            track(ANALYTICS_EVENTS.PRODUCTION_CREATED, {
              production_id: data?._id,
              studio_id: data?.studio?.[0] ?? undefined,
            });
            updateProductionBreadcrumbs(data?._id, data?.name);
            // const redirectionData = [
            //   {
            //     name: 'production Details',
            //     type: 'details',
            //     title: data?.name,
            //     path: `${ROUTES.PRODUCTION_DETAIL}/${data?._id}`,
            //     // selectedEntity: selectedEntity,
            //   },
            // ];
            // setBreadCrumbs(redirectionData);

            setSubmitStatus(false);
            notify('Production added successfully', 'success');
            removeContactsList([]);
            setBase64File('');
            navigate(`${ROUTES.PRODUCTION_DETAIL}/${data?._id}`);
          }
        }),
      );

      dispatch(setProductionFormDetails({}));
    }
  };

  useFormErrorListener(formRef, errors);

  if (loading && productionId) {
    return <Loading type="div" pageLoading />;
  }

  return (
    <>
      <div className="pageBody">
        <PageHeading
          // navigateUrl={-1}
          pageTitle={productionId ? 'Edit Project' : 'Create Project'}
          pageName={productionId ? 'Edit Project' : 'Create Project'}
          isNestedBreadcrum
          breadcrumNested={
            <BreadcrumNested
              breadcrums={[
                { name: 'Project Management', url: -1 },
                {
                  name: productionId ? 'Edit Project' : 'Create Project',
                  url: '',
                },
              ]}
            />
          }
        />
        <div className="formScroller lg-inputs">
          <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
            <div>
              <SectionContainer
                heading="Project Detail"
                children={
                  <div className="formContainer">
                    <Grid container spacing={2}>
                      <Grid item md={4} xs={12}>
                        <InputField
                          requiredField
                          id="name"
                          label="Project Name"
                          name="name"
                          placeholder="Enter project name"
                          control={control}
                          maxLength={50}
                          error={!!errors['name']}
                          helperText={
                            !!errors['name'] ? errors['name'].message : ''
                          }
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <AutocompleteSelect
                          id="Production Type *"
                          labelText="Project/Live Event Type"
                          placeHolderText="Select Project Type"
                          options={PRODUCTION_TYPES}
                          control={control}
                          name="type"
                          defaultValue={''}
                          disabled={productionId}
                          setValue={setValue}
                          requiredField
                          error={!!errors['type']}
                          helperText={
                            !!errors['type'] ? errors['type'].message : ''
                          }
                        />
                      </Grid>
                      {watch('type') === 'Other' && (
                        <Grid item md={4} xs={12}>
                          <InputField
                            requiredField
                            id="customProductionType"
                            label="Custom Project Type"
                            name="customProductionType"
                            placeholder="Enter custom project type"
                            control={control}
                            // disabled={!editMode}
                            error={!!errors['customProductionType']}
                            helperText={
                              !!errors['customProductionType']
                                ? errors['customProductionType'].message
                                : ''
                            }
                            // Optional, defaults to true
                            // value={edit ? editDetails?.empName : ''}
                          />
                        </Grid>
                      )}
                      <Grid item md={12} xs={12} className="chat_count">
                        <Textarea
                          id="description"
                          name="description"
                          placeholder="Description"
                          label="Description"
                          rows={5}
                          charLimit={1000}
                          // requiredField
                          control={control}
                          error={!!errors['description']}
                          helperText={
                            !!errors['description']
                              ? errors['description'].message
                              : ''
                          }
                        />
                        {watch('description')?.length ? (
                          <div
                            className={`hint_text  ${
                              !!errors['description'] ? 'hint_has_error' : null
                            }`}
                          >
                            <span>
                              {watch('description')?.length + '/1000'}
                            </span>
                          </div>
                        ) : null}
                      </Grid>
                    </Grid>
                    {/* Shedule Section */}

                    <Schedule
                      control={control}
                      errors={errors}
                      watch={watch}
                      setValue={setValue}
                      // addButton={!state?.editProduction || state?.isAdmin}
                      getValues={getValues}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      // disabled={!editMode}
                    />

                    {/* Shedule Section */}
                  </div>
                }
              />

              <SectionContainer
                heading="Associated Studio/Prod Co./client"
                children={
                  <div className="formContainer">
                    <ClientSection
                      control={control}
                      errors={errors}
                      watch={watch}
                      setValue={setValue}
                      // addButton={!state?.editProduction || state?.isAdmin}
                      getValues={getValues}
                      // disabled={!editMode}
                      clearErrors={clearErrors}
                      handleClose={handleClose}
                    />

                    {/* <ClientSection 
                    
                    /> */}
                  </div>
                }
              />

              <SectionContainer
                heading="Project Address"
                children={
                  <Address
                    control={control}
                    errors={errors}
                    watch={watch}
                    setValue={setValue}
                    // addButton={!state?.editProduction || state?.isAdmin}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    trigger={trigger}
                  />
                }
              />

              {!productionId && (
                <SectionContainer
                  heading="Add Contacts"
                  children={
                    <>
                      {contacts?.length ? (
                        <>
                          <div className="flex end mb_15">
                            <CustomButton
                              size="large"
                              variant="contained"
                              // text="Create"
                              text="Add"
                              width="auto"
                              // type="submit"
                              disabled={disabled}
                              id="drafted"
                              showIcon={true}
                              icon={Images.Plus_White}
                              iconPosition="start"
                              onClick={() => {
                                updateProductionFormDetails({
                                  ...getValues(),
                                  ...(base64File && { image: base64File }),
                                  ...(documentFields && {
                                    documents: documentFields,
                                  }),
                                });
                                navigate(
                                  ROUTES?.ADD_CONTACT_ROLES_PRODUCTION +
                                    '?isCreation=true',
                                );
                              }}
                            />
                          </div>
                          <ContactsTable data={contacts} />
                        </>
                      ) : (
                        <NoData
                          heading="No contacts added yet!"
                          title="You have not added any contacts yet."
                          buttonText="Add"
                          handleClick={() => {
                            updateProductionFormDetails({
                              ...getValues(),
                              ...(base64File && { image: base64File }),
                              ...(documentFields && {
                                documents: documentFields,
                              }),
                            });
                            navigate(
                              ROUTES?.ADD_CONTACT_ROLES_PRODUCTION +
                                '?isCreation=true',
                            );
                          }}
                          showIconButton
                          buttonIcon={Images.Plus_White}
                          // className='add_contact_episode'
                        />
                      )}

                      {/* <AddContact /> */}
                    </>
                  }
                />
              )}
              {base64File != undefined && (
                <SectionContainer
                  heading="Attach Project Image"
                  children={
                    <div className="formContainer">
                      <Grid container spacing={2} mb={2.2}>
                        <Grid item md={12} xs={12}>
                          <Info
                            theme="light"
                            infoText="Upload this image in a 2:1 aspect ratio as it will be displayed on the production detail page as a feature graphic."
                          />
                        </Grid>
                      </Grid>

                      <div className="imageContainer">
                        {!base64File && (
                          <ImageCropperInput
                            setLoad={setLoad}
                            setProgress={setUploadProgress}
                            setUrl={setBase64File}
                            loading={load}
                            ratio={2 / 1}
                            title="Add Image"
                            // descTxt="or drag and drop here"
                            onlyImage={true}
                          />
                        )}
                        {base64File && (
                          <div className="">
                            <div className="imageItem ">
                              <Box className="selectimg_video">
                                {/* {base64File?.length > 80 && ( */}

                                <IconButton
                                  className="removeImage"
                                  onClick={() => {
                                    setBase64File('');

                                    // reset({ file: '' })
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>

                                {/* )} */}
                                <figure className="selected">
                                  <img src={base64File} alt={'more'} />
                                </figure>
                              </Box>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  }
                />
              )}

              {!productionId && (
                <SectionContainer
                  heading="Attach Document"
                  children={
                    <div className="formContainer">
                      <Grid container spacing={2} mb={2.2}>
                        <Grid item md={12} xs={12}></Grid>
                      </Grid>

                      <div className="imageContainer">
                        {documentFields.length < 20 ? (
                          <ImageCropperInput
                            setLoad={setLoad}
                            setProgress={setUploadProgress}
                            setUrl={setDocument}
                            loading={load}
                            ratio={2 / 1}
                            title="Add Document"
                            type="Document"
                            //   descTxt="or drag and drop here"
                            setDepartment={setDepartment}
                            onAddDocument={handleAddDocument}
                            guideline={true}
                            showDeptSignup
                          />
                        ) : (
                          <p className="MuiTypography-body2 text-error_600">
                            Maximum of 20 documents can be uploaded.
                          </p>
                        )}
                      </div>

                      <div className="doc-cards mt-12">
                        <Grid container spacing={2}>
                          {documentFields.map((item: any, index: number) => {
                            const fileExtension = item?.documentUrl
                              ?.split('.')
                              .pop()
                              ?.toLowerCase();
                            const isImage = [
                              'jpg',
                              'jpeg',
                              'png',
                              'gif',
                              'bmp',
                              'webp',
                            ].includes(fileExtension || '');

                            const isPDF = fileExtension === 'pdf';
                            return (
                              <Grid item md={6} xs={12} key={index}>
                                <div className="doc-card">
                                  <span className="icon">
                                    <i
                                      className={
                                        isPDF
                                          ? 'pdf-icon'
                                          : isImage
                                          ? 'img-icon'
                                          : 'link-icon'
                                      }
                                    ></i>
                                  </span>
                                  <p className="MuiTypography-body2 fw600">
                                    {item.docName}
                                  </p>

                                  <button
                                    className="dlt-btn ml-auto"
                                    type="button"
                                    onClick={() => removeDocuments(index)}
                                  >
                                    <i className="delete-icon"></i>
                                  </button>
                                </div>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </div>
                    </div>
                  }
                />
              )}

              <div className="formButtons end">
                <CustomButton
                  onClick={() => {
                    setOpenwarn(true);
                  }}
                  size="large"
                  variant="outlined"
                  text="Cancel"
                  width="auto"
                  type="button"
                  id="cancel"
                  showIcon={false}
                />

                <CustomButton
                  size="large"
                  variant="contained"
                  // text="Create"
                  text={productionId ? 'Update' : 'Create'}
                  width="auto"
                  type="submit"
                  disabled={productionId ? false : !isValid}
                  id="drafted"
                  showIcon={false}
                  // onClick={() => {}}
                />
              </div>
            </div>
            <WarningDialog
              open={openwarn}
              // handleClose={() => {
              //   setOpenwarn(false)
              //   navigate(-1)
              // }}
              title="Cancel Project?"
              description="Are you sure you want to cancel the project?"
              type="warning"
              handleClose={() => setOpenwarn(false)}
              onClick={() => {
                setOpenwarn(false);
                navigate(-1);
              }}
              cancelBtnText="Cancel"
              confirmBtnText="Yes, Sure"
              showIcon={false}
            />
          </form>
        </div>

        <StuioCreate
          open={studioOpen}
          handleClose={handleClose}
          setValueofStudio={setValue}
          getValuesStudio={getValues}
        />

        <WarningDialog
          open={open}
          handleClose={() => {
            setOpen;
          }}
          title="Delete"
          description="Do you want to delete this banner?"
          type="warning"
          // onClick={() => {}}
          cancelBtnText="Cancel"
          confirmBtnText="Delete"
          showIcon={false}
        />
      </div>
    </>
  );
}
